module.exports = __webpack_public_path__ + "static/media/book.a8f683b3.svg";